/**
 * Diagram export: PNG, blob download, Excel, save/load model.
 * Uses window.myDiagram, window.go, jQuery, DataTable, sessionStorage, document.
 */
const go = typeof window !== 'undefined' ? window.go : null;

function save() {
  if (!window.myDiagram) return;
  const el = document.getElementById('mySavedModel');
  if (el) el.value = window.myDiagram.model.toJson();
  window.myDiagram.isModified = false;
}

function load() {
  if (!window.myDiagram || !go) return;
  const el = document.getElementById('mySavedModel');
  if (!el) return;
  window.myDiagram.model = go.Model.fromJson(el.value);
  let lastkey = 1;
  window.myDiagram.model.makeuniqueStringKeyFunction = function (model, data) {
    let k = data.key || lastkey;
    while (model.findNodeDataForKey(k)) k++;
    data.key = lastkey = k;
    return k;
  };
}

function createImage() {
  if (!window.myDiagram) return;
  const newWindow = window.open('', 'newWindow');
  if (!newWindow) return;
  const newDocument = newWindow.document;
  const png = window.myDiagram.makeImage({
    maxSize: new go.Size(100000, 100000),
    type: 'image/png'
  });
  newDocument.body.appendChild(png);
}

function myCallback(blob) {
  const url = window.URL.createObjectURL(blob);
  const filename = 'Arxena.png';
  const a = document.createElement('a');
  a.style = 'display: none';
  a.href = url;
  a.download = filename;

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
    return;
  }

  document.body.appendChild(a);
  requestAnimationFrame(function () {
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  });
}

function makeBlob() {
  if (!window.myDiagram) return;
  const user = JSON.parse(localStorage['user']);
  if (user['plan']['plan'] == 'plan_0') {
    if (typeof export_paid_feature_modal !== 'undefined' && typeof $ !== 'undefined') {
      $(export_paid_feature_modal).modal('show');
    }
    if (typeof PageContents !== 'undefined') {
      new PageContents().changePage('/dashboard');
    }
    sessionStorage['lateral_bar'] = 'closed';
  } else {
    window.myDiagram.makeImageData({
      maxSize: new go.Size(100000, 100000),
      size: new go.Size(10000, NaN),
      returnType: 'blob',
      callback: myCallback
    });
  }
}

function createExcelFromData(data) {
  const existing_org_data = data;
  const table_top = '<table id="datatable">';
  const table_headers = '<thead><tr><th>full_name</th><th>job_company_id</th><th>job_company_name</th><th>job_company_website</th><th>location_name</th><th>industry</th><th>job_title</th><th>linkedin_url</th><th>facebook_url</th><th>twitter_url</th><th>phone_numbers</th><th>emails</th></tr></thead>';
  const table_bottom = '</table>';

  let rows_for_export = '';
  const people = existing_org_data;
  for (let j = 0; j < people.length; j++) {
    const rowEl = document.getElementById('row_element_for_excel_export');
    if (!rowEl) continue;
    rows_for_export = rows_for_export + rowEl.innerHTML
      .replace(/{full_name}/g, people[j]['full_name'] ? people[j]['full_name'] : '')
      .replace(/{job_title}/g, people[j]['job_title'] ? people[j]['job_title'] : '')
      .replace(/{linkedin_url}/g, people[j]['linkedin_url'] ? people[j]['linkedin_url'] : '')
      .replace(/{facebook_url}/g, people[j]['facebook_url'] ? people[j]['facebook_url'] : '')
      .replace(/{twitter_url}/g, people[j]['twitter_url'] ? people[j]['twitter_url'] : '')
      .replace(/{industry}/g, people[j]['industry'] ? people[j]['industry'] : '')
      .replace(/{job_company_id}/g, people[j]['job_company_id'] ? people[j]['job_company_id'] : '')
      .replace(/{job_company_name}/g, people[j]['job_company_name'] ? people[j]['job_company_name'] : '')
      .replace(/{job_company_website}/g, people[j]['job_company_website'] ? people[j]['job_company_website'] : '')
      .replace(/{location_name}/g, people[j]['location_name'] ? people[j]['location_name'] : '')
      .replace(/{emails}/g, people[j]['emails'] ? people[j]['emails'] : '')
      .replace(/{phone_numbers}/g, people[j]['phone_numbers'] ? people[j]['phone_numbers'] : '');
  }

  const table_total = table_top + table_headers + rows_for_export + table_bottom;
  const excelExportTable = document.getElementById('excel_export_table');
  if (excelExportTable) excelExportTable.innerHTML = table_total;

  if (typeof $ !== 'undefined' && typeof $.fn.DataTable !== 'undefined') {
    const table = $('#datatable').DataTable({
      dom: 'Bfrtip',
      buttons: [{ extend: 'excel', title: 'People Data Export' }]
    });
    table.button(0).trigger();
  }
}

function downloadNodeDatatoExcel(e, obj) {
  if (!window.myDiagram || !obj || !obj.part) return;
  const clicked_key_no = obj.part.key;
  const nodeData = window.myDiagram.findNodeForKey(clicked_key_no);
  if (!nodeData || !nodeData.data || !nodeData.data.candidates) return;
  const people_data = nodeData.data.candidates;
  createExcelFromData(people_data);
}

function downloadExcel() {
  if (!sessionStorage['people_data']) return;
  const existing_org_data = JSON.parse(sessionStorage['people_data']);
  createExcelFromData(existing_org_data);
}

function downloadPeopleResults() {
  downloadExcel();
}

function saveToList() {
  downloadExcel();
}

export {
  save,
  load,
  createImage,
  makeBlob,
  myCallback,
  createExcelFromData,
  downloadNodeDatatoExcel,
  downloadExcel,
  downloadPeopleResults,
  saveToList
};
